import { RemoteCourseList } from 'data/usecases';
import { makeApiUrlCourse } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCourseList = (): RemoteCourseList => {
  return new RemoteCourseList(makeApiUrlCourse(), makeAxiosHttpClient());
};
